import { render, staticRenderFns } from "./spokesman-reward.vue?vue&type=template&id=5de3f018&scoped=true"
import script from "./spokesman-reward.vue?vue&type=script&lang=js"
export * from "./spokesman-reward.vue?vue&type=script&lang=js"
import style0 from "./spokesman-reward.vue?vue&type=style&index=0&id=5de3f018&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de3f018",
  null
  
)

export default component.exports